import { render } from "./TeacherResponseReport.vue?vue&type=template&id=b374f5c4&scoped=true"
import script from "./TeacherResponseReport.vue?vue&type=script&lang=js"
export * from "./TeacherResponseReport.vue?vue&type=script&lang=js"

import "./TeacherResponseReport.vue?vue&type=style&index=0&id=b374f5c4&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-b374f5c4"]])

export default __exports__